import { AgentModal } from "@zapier/agents";
import { CanvasModal } from "@zapier/canvases";
import { ChatbotModal, HydratedChatbotWithFolder } from "@zapier/chatbots";
import {
  FolderTreeItem,
  HydratedAgent,
  HydratedCanvas,
  HydratedChatbotAsset,
  HydratedTable,
  HydratedZapAsset,
  Interface,
  Zap,
} from "@zapier/client";
import { InterfaceModal } from "@zapier/interfaces";
import { FolderModal, ZapModal } from "@zapier/shared";
import { TableModal } from "@zapier/tables";
import { ApprovalType } from "@zapier/utils";
import { useState } from "react";

/** This hook manages state for multiple asset modals that appear as siblings to
 * the Asset table in the UI.
 */

type AssetModal =
  | ZapModal
  | FolderModal
  | TableModal
  | InterfaceModal
  | CanvasModal
  | ChatbotModal
  | AgentModal;

export function useMultiAssetModalStates() {
  const [currentModal, setCurrentModal] = useState<AssetModal | undefined>();
  const [approvalType, setApprovalType] = useState<ApprovalType | undefined>();

  const [currentZap, setCurrentZap] = useState<
    Zap | HydratedZapAsset | undefined
  >();
  const [currentFolder, setCurrentFolder] = useState<
    FolderTreeItem | undefined
  >();
  const [currentTable, setCurrentTable] = useState<HydratedTable | undefined>();
  const [currentInterface, setCurrentInterface] = useState<
    Interface | undefined
  >();
  const [currentCanvas, setCurrentCanvas] = useState<
    HydratedCanvas | undefined
  >();
  const [currentChatbot, setCurrentChatbot] = useState<
    HydratedChatbotAsset | HydratedChatbotWithFolder | undefined
  >();
  const [currentAgent, setCurrentAgent] = useState<HydratedAgent | undefined>();

  return {
    // Modal
    currentModal,
    setCurrentModal,
    // Approval
    approvalType,
    setApprovalType,
    // Folder
    currentFolder,
    setCurrentFolder,
    // Zap
    currentZap,
    setCurrentZap,
    // Table
    currentTable,
    setCurrentTable,
    // Interface
    currentInterface,
    setCurrentInterface,
    // Canvas
    currentCanvas,
    setCurrentCanvas,
    // Chatbot
    currentChatbot,
    setCurrentChatbot,
    // Agent
    currentAgent,
    setCurrentAgent,
  };
}
